import { TCText } from "../../../components/TCText/TCText";
import { Colors } from "../../../utils/colors";
import { MatchStat } from "./MatchStat";
import { observer } from "mobx-react-lite";
import { useMatchDetailsStore } from "../../../stores/StoreContext";

export const MatchStats = observer(() => {
  const { matchClutchStats } = useMatchDetailsStore();
  return matchClutchStats?.matchStatsDetails?.matchTimeInPlayMinutes ? (
    <div
      style={{
        backgroundColor: Colors.white,
        width: "100%",
        padding: "20px 14px",
        marginTop: 20,
        borderRadius: 20,
      }}>
      <TCText value="Match Stats" style={{ fontWeight: 600, fontSize: 16 }} />
      <div
        style={{
          marginTop: 20,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingLeft: 20,
          paddingRight: 20,
          gap: 20,
        }}>
        <MatchStat
          value={
            matchClutchStats?.matchStatsDetails?.matchTimeInPlayMinutes?.toString() ??
            "0"
          }
          title="Match time in play minutes"
        />
        <MatchStat
          value={
            matchClutchStats?.matchStatsDetails?.longestRallySeconds?.toString() ??
            "0"
          }
          title="Longest rally seconds"
        />
      </div>
      <div
        style={{
          marginTop: 20,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingLeft: 20,
          paddingRight: 20,
          gap: 20,
        }}>
        <MatchStat
          value={
            matchClutchStats?.matchStatsDetails?.longestRallyShots?.toString() ??
            "0"
          }
          title="Longest rally shots"
        />
        <MatchStat
          value={
            matchClutchStats?.matchStatsDetails?.avgRallyShots?.toString() ??
            "0"
          }
          title="Average rally shots"
        />
      </div>
    </div>
  ) : null;
});
